import { create } from 'zustand';

export enum HelpPages {
  Root = 0,
  ReportIssue = 1,
  ConfidentialHotline = 2,
  FAQ = 3
}

interface Store {
  page: HelpPages;
  open: boolean;
  /** Root menu item to focus after returning from a sub-page. */
  returnFocusTo: HelpPages | null;
  setPage(page: HelpPages): void;
  clearReturnFocus(): void;
  toggle(open?: boolean): void;
}

export const useHelpStore = create<Store>((set, get) => ({
  page: HelpPages.Root,
  open: false,
  returnFocusTo: null,
  setPage: page => {
    const { page: current } = get();

    // Remember which sub-page we left so Root can restore focus to that menu item.
    if (page === HelpPages.Root && current !== HelpPages.Root) {
      set({ page, returnFocusTo: current });
      return;
    }

    set({ page, returnFocusTo: null });
  },
  clearReturnFocus: () => set({ returnFocusTo: null }),
  toggle: open => {
    const next = open === undefined ? !get().open : open;
    if (!next) {
      set({
        open: false,
        page: HelpPages.Root,
        returnFocusTo: null
      });
      return;
    }
    set({ open: true, returnFocusTo: null });
  }
}));
